angular.module('mso.interceptors').factory('authenticationInterceptor', ['$rootScope', '$q', '$window', '$location', function ($rootScope, $q, $window, $location) {
    'use strict';
    return {
        request: function (config) {
            config.headers = config.headers || {};
            if ($window.sessionStorage.token) {
                config.headers.Authorization = 'Bearer ' + $window.sessionStorage.token;

                if ($window.sessionStorage.lockToken) {
                    config.headers.lockId = $window.sessionStorage.lockToken;
                }
            }
            return config;
        },
        responseError: function (rejection) {
            var location = "";

            if(rejection.status === 405){
                location = "";
                location += '/case-home-ui/' +  rejection.data.caseId + '/case-home?accessMessage=' + rejection.data.message;
                $window.location.href = location;
            }

            return $q.reject(rejection);
        }
    };
}]).config(['$httpProvider', function ($httpProvider) {
    'use strict';
    $httpProvider.interceptors.push('authenticationInterceptor');
}]);

